// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"d158a700","869":"693d94bc"}[chunkId] + ".chunk.js";
};